export const APP_VERSION = "2026.09.21";
export default APP_VERSION;
